import React from 'react';
import Marquee from 'react-fast-marquee';

import {IScrollingStripeBannerProps} from './IScrollingStripeBanner';

import styles from './ScrollingStripeBanner.module.scss';

// Extend the CSSProperties type
interface MyCSSProperties extends React.CSSProperSties {
	[key: string]: any;
}

const ScrollingStripeBanner = ({direction, autoFill, spacing, contentColor, speed, item}: IScrollingStripeBannerProps) => {
	return (
		<div className={styles['scrolling-stripe-banner']}>
			<Marquee
				className={`direction-${direction}`}
				style={
					{
						'--spacing': `${autoFill ? spacing || '10' : '0'}px`,
						'--content-color': contentColor,
					} as MyCSSProperties
				}
				speed={speed || 50}
				direction={direction || 'left'}
				autoFill={autoFill || false}
			>
				{item &&
				<>
					{item}
				</>
				}
			</Marquee>
		</div>
	);
};

export default ScrollingStripeBanner;
